export const VG_START_SIGNALR_CONN = "VG_START_SIGNALR_CONN";
export const VG_STARTED_SIGNALR_CONN = "VG_STARTED_SIGNALR_CONN";
export const VG_STOP_SIGNALR_CONN = "VG_STOP_SIGNALR_CONN";
export const VG_STOPPED_SIGNALR_CONN = "VG_STOPPED_SIGNALR_CONN";
export const VG_RECONNECTING_SIGNALR_CONN = "VG_RECONNECTING_SIGNALR_CONN";
export const VG_RECONNECTED_SIGNALR_CONN = "VG_RECONNECTED_SIGNALR_CONN";
export const VG_FAILED_SIGNALR_CONN = "VG_FAILED_SIGNALR_CONN";
export const VG_SET_MESSAGE = "VG_SET_MESSAGE";
export const VG_REMOVE_MESSAGE = "VG_REMOVE_MESSAGE";
export const VG_REMOVE_ALL_MESSAGES = "VG_REMOVE_ALL_MESSAGES";
export const LOGOUT_EVENT = "LOGOUT_EVENT";
